export const formatPrice = (price, currencySymbol) => {
  if (!price) {
    return price;
  }

  let formattedPrice = price.toFixed(2);
  formattedPrice = formattedPrice.toString().replace('.', ',');

  return `${formattedPrice} ${currencySymbol}`;
};

export const formatDate = (date) => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};

export const defaultConsentState = {
  preferences: false,
  statistics: false,
  marketing: false,
  doNotTrack: false,
};

export const getCookiebotConsentState = () => {
  if (!window.Cookiebot) return defaultConsentState;
  const { consent, doNotTrack } = window.Cookiebot;

  return {
    preferences: consent.preferences === true ? true : false,
    statistics: consent.statistics === true ? true : false,
    marketing: consent.marketing === true ? true : false,
    doNotTrack: doNotTrack === true ? true : false,
  };
};
